import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Flex, Spinner } from "@chakra-ui/react";

const API_BASE_URL = "https://qaapirgeneng.digitalfields.co.za/ws1.cfc";
const DEFAULT_CLIENT_ID = "11";

const loadProfilePage = async (clientId) => {
    try {
        const mod = await import(`./Profile${clientId}.js`);
        return mod.default;
    } catch {
        const mod = await import("./Profile11.js");
        return mod.default;
    }
};

const ProfileRouter = () => {
    const { clientId } = useParams();
    const [hclientID, setHclientID] = useState(null);
    const [ProfilePage, setProfilePage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAndLoadProfile = async () => {
            const HuserID = localStorage.getItem("HuserID");
            const UUID = localStorage.getItem("UUID");
            let resolvedId = DEFAULT_CLIENT_ID;

            try {
                const response = await fetch(
                    `${API_BASE_URL}?method=getProfileDets&huserID=${HuserID}&uuid=${UUID}`,
                    { method: "GET" }
                );
                const data = await response.json();
                resolvedId = String(data[0]?.HclientID ?? DEFAULT_CLIENT_ID);
            } catch {
                resolvedId = DEFAULT_CLIENT_ID;
            }

            setHclientID(resolvedId);
            const PageComponent = await loadProfilePage(resolvedId);
            setProfilePage(() => PageComponent);
            setLoading(false);
        };

        fetchAndLoadProfile();
    }, []);

    if (loading || !ProfilePage || !hclientID) {
        return (
            <Flex justify="center" align="center" minH="50vh">
                <Spinner size="xl" />
            </Flex>
        );
    }

    if (clientId !== hclientID) {
        return <Navigate to={`/profile/${hclientID}`} replace />;
    }

    return <ProfilePage hclientID={Number(hclientID)} />;
};

export default ProfileRouter;
